<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">'
  <defs><style>.icon{fill:currentColor;}</style></defs>
  <path class="icon" d="M100,72.57H98.27c-7.69,0-14.3-6.82-18.46-11.85-5.94-7.16-15.29-20.38-21.47-28.2-5-6.36-11.42-6.17-16.68,0C35.35,39.93,27.12,53,20.19,60.72,15.84,65.58,9.42,72.57,1.73,72.57H0"/>
</svg>